// Node
import noUiSlider from "nouislider";
import * as React from "react";

const MIN_DISTANCE = 0;

export default class DistanceRange extends React.Component {
  constructor (props) {
    super(props);
    this.interacted = false;
    this.slider = null;
    this.distance = this.normalizeDistance(this.props.value);
    this.interaction = this.interaction.bind(this);
    this.handleMinInputChange = this.handleMinInputChange.bind(this);
    this.handleMaxInputChange = this.handleMaxInputChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    if (location.href.includes('#map_opened')) {
      this.interaction();
    }
  }

  componentDidMount() {
    // Создаем слайдер.
    // min и max должны отличаться
    this.slider = noUiSlider.create(document.getElementById(`${this.props.filterValue}Slider`), {
      start: this.distance,
      connect: true,
      animation: true,
      range: {
        'min': MIN_DISTANCE,
        'max': this.props.max_distance || 1
      }
    });

    let component = this;
    // Обновляем
    // инпут только во время перетягивания слайдера.
    this.slider.on('update', function (values, handle) {
      document.getElementById(`${component.props.filterValue}SliderMin`).value =
        Math.round(values[0]);

      document.getElementById(`${component.props.filterValue}SliderMax`).value =
        Math.round(values[1]);
    });

    // Сортируем базы и запоминаем растояние, когда слайдер остановился.
    this.slider.on('change', function (values, handle) {
      // Если выбран город, это подгрузит еще и ОР области (логика Совы).
      if (!component.interacted) {
        component.interaction();
      }
      window.ymReachGoal('filter:slider:sliderChange');

      const min = Math.round(values[0]);
      const max = Math.round(values[1]);

      if (min === MIN_DISTANCE) {
        component.props.filter(component.props.filterValue, max);
      } else {
        component.props.filter(component.props.filterValue, [min, max]);
      }
    });
  }

  shouldComponentUpdate(nextProps) {
    return this.props.value != nextProps.value;
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.slider.set(this.normalizeDistance(nextProps.value));
    }
  }

  // Взаимодействовали со слайдером
  interaction() {
    if (this.props.distanceInteraction != null) {
      this.props.distanceInteraction();
    }
    this.interacted = true;
  }

  // После ввода значения в инпут сохраняем его, перетаскиваем слайдер и сортируем базы.
  handleMinInputChange(event) {

    const value = event.target.value;
    clearTimeout(this.minTimeout);
    this.minTimeout = setTimeout(() => {
      this.applyValue('min', value);
    }, 2000);
  }

  handleMaxInputChange(event) {

    const value = event.target.value;
    clearTimeout(this.maxTimeout);
    this.maxTimeout = setTimeout(() => {
      this.applyValue('max', value);
    }, 2000);
  }
  handleInputChange(event) {
    let value = event.target.value;
    clearTimeout(this.inputTimeout);
    this.inputTimeout = setTimeout(() => {
      this.applyValue(value);
    }, 2000);
  }

  applyValue(type, value) {
    const inputValue = parseInt(value, 10);

    if (isNaN(inputValue)) return;

    let [min, max] = this.slider.get().map(v => Math.round(v));

    if (type === 'min') {
      min = Math.max(MIN_DISTANCE, Math.min(inputValue, max));
    } else {
      max = Math.min(
        this.props.max_distance || 1,
        Math.max(inputValue, min)
      );
    }

    window.ymReachGoal('filter:slider:inputChange');

    this.slider.set([min, max]);

    if (min === MIN_DISTANCE) {
      this.props.filter(this.props.filterValue, max);
    } else {
      this.props.filter(this.props.filterValue, [min, max]);
    }
  }

  normalizeDistance(value) {
    const maxDistance = this.props.max_distance || 1;

    if (Array.isArray(value)) {
      return [
        Number(value[0] ?? MIN_DISTANCE),
        Number(value[1] ?? maxDistance),
      ];
    }

    if (value && typeof value === 'object') {
      return [
        Number(value.min ?? MIN_DISTANCE),
        Number(value.max ?? maxDistance),
      ];
    }

    return [
      MIN_DISTANCE,
      Number(value ?? this.props.default_distance ?? maxDistance),
    ];
  }

  render() {
    return (
      <div className='filter-row'>
        <div className='filter-row__title'>
          {this.props.title}
        </div>
        <div className='pick-line pick-line-prices pick-line-one'>
          <div className='pick-input'>
            <div className='pick-input__box'>
              <input type='text'
                     className='pick-price-input-short short'
                     id={`${this.props.filterValue}SliderMin`}
                     defaultValue={this.distance[0]}
                     onChange={this.handleMinInputChange}
              />
              <span className='pick-input__box-currency'>км</span>
            </div>
          </div>

          <div className='pick-input'>
            <div className='pick-input__box'>
              <input type='text'
                     className='pick-price-input-short short'
                     id={`${this.props.filterValue}SliderMax`}
                     defaultValue={this.distance[1]}
                     onChange={this.handleMaxInputChange}
              />
              <span className='pick-input__box-currency'>км</span>
            </div>
          </div>
        </div>
        <div className='pick-line pick-line-one pick-line-prices-slider'>
          <div id={`${this.props.filterValue}Slider`}/>
        </div>
      </div>
    );
  }
}
